import { ChargeWaiverEntity, EMPTY_CHARGE_WAIVER_DETAIL_ENTITY } from "domain/entity/ChargeWaiver/ChargeWaiverEntity";
import { ChargeWaiverSearchCriteria, EMPTY_CHARGE_WAIVER_SEARCH_CRITERIA } from "domain/entity/ChargeWaiver/ChargeWaiverSearchCriteria";
import { RefObject } from "react";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface ChargeWaiverDropdownOptions {
    consortiumCodeDropdownOptions: DropdownProps[],
    waiverReasonDropdownOptions: DropdownProps[],
    rejectReasonDropdownOptions: DropdownProps[],
    reverseReasonDropdownOptions: DropdownProps[],
}
export interface ChargeWaiverChangeState extends BaseViewChangeSate {
    //currentSelectedData: EmptyPoolStorageEntity
}

export interface ChargeWaiverModel {
    masterState: ChargeWaiverChangeState,
    isLoading: boolean,
    isShowRightPanel: boolean,
    isFilterSearchCriteria: boolean,
    isEditSearchCriteria: boolean,
    checkboxRef: { [key: string]: HTMLElement | null },
    //checkboxValue: EmptyPoolStorageGenEnabledSearchCriteria,
    searchCriteria: ChargeWaiverSearchCriteria,
    highlightedCheckboxKey?: string | null
    currentTableRef?: RefObject<any>,
    searchCounter: number,
    dynamicOptions: ChargeWaiverDropdownOptions,
    isShowDetail: boolean,
    //emptyPoolDatas: EmptyPoolStorageEntity[],    
    //selectedEmptyPoolDatas: EmptyPoolStorageEntity[],
    isShowCriteriaPanel: boolean,
    isShowReversePanel: boolean,
    isShowRejectPanel: boolean,
    allFormState?: { [x: string]: string },
    chargeWaiverList: ChargeWaiverEntity[],
    allChargeWaiverList: ChargeWaiverEntity[],
    selectedRows: ChargeWaiverEntity[],
    currentSelectedData: ChargeWaiverEntity,
    editData: ChargeWaiverEntity,
    isBackFromDetail: boolean,
    isAllowAutoSearch: boolean,
    isWaitForApproval: boolean,
    isDisapproved: boolean,
    isApproval: boolean,
    isSubmit: boolean,
    isWaitForApprovalCount: number,
    isDisapprovedCount: number,
    isApprovalCount: number,
    isSubmitCount: number,
    poNo: string,
    ourRef: string,
    yourRef: string,
    remarks: string,
    isShowEditPanel: boolean,
    isShowBulkEditPanel: boolean,
    isShowDelayDelivery: boolean,
    isShowStackHold: boolean,
    isShowDelayGrding: boolean,
    isShowRolloverChg: boolean,
    isShowGenWaiverByCom: boolean,
    showApproveRejectPanel: string,
    approveRejactReasonCode: string,
    forceRefresh: boolean,
    editForceRefresh: boolean,
    reasonCode: string | null,
    isSearchLoading: boolean,
}

export const EMPTY_CHARGE_WAIVER_MODEL: ChargeWaiverModel = {
    isLoading: false,
    isShowRightPanel: false,
    isFilterSearchCriteria: false,
    isEditSearchCriteria: false,
    checkboxRef: {},
    //checkboxValue: { ...DEFAULT_ENABLED_EMPTY_POOL_STORAGE_GEN_SEARCH_CRITERIA },
    searchCriteria: { ...EMPTY_CHARGE_WAIVER_SEARCH_CRITERIA },
    searchCounter: 0,
    dynamicOptions: {
        consortiumCodeDropdownOptions: [],
        waiverReasonDropdownOptions: [],
        rejectReasonDropdownOptions: [],
        reverseReasonDropdownOptions: [],
    },
    isShowDetail: false,
    //emptyPoolDatas: [],    
    //selectedEmptyPoolDatas: [],
    isShowCriteriaPanel: false,
    isShowReversePanel: false,
    isShowRejectPanel: false,
    allFormState: {},
    chargeWaiverList: [],
    allChargeWaiverList: [],
    selectedRows: [],
    currentSelectedData: { ...EMPTY_CHARGE_WAIVER_DETAIL_ENTITY },
    editData: { ...EMPTY_CHARGE_WAIVER_DETAIL_ENTITY },
    isBackFromDetail: false,
    isAllowAutoSearch: true,
    isWaitForApproval: false,
    isDisapproved: false,
    isApproval: false,
    isSubmit: false,
    isWaitForApprovalCount: 0,
    isDisapprovedCount: 0,
    isApprovalCount: 0,
    isSubmitCount: 0,
    poNo: "",
    isShowEditPanel: false,
    isShowBulkEditPanel: false,
    isShowDelayDelivery: false,
    isShowStackHold: false,
    isShowDelayGrding: false,
    isShowRolloverChg: false,
    isShowGenWaiverByCom: false,
    showApproveRejectPanel: "",
    approveRejactReasonCode: "",
    forceRefresh: false,
    editForceRefresh: false,
    ourRef: "",
    yourRef: "",
    remarks: "",
    reasonCode: null,
    isSearchLoading: true,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    },
}